(function () {

    'use strict';

    angular.module('Services').service('AccountingSurchargesTableService', AccountingSurchargesTableService);

    AccountingSurchargesTableService.$inject = ['AccountingService', 'TableLiteFactory', '$location'];

    function AccountingSurchargesTableService(AccountingService, TableLiteFactory, $location) {
        return function () {
            const tableData = {
                tableName: 'AccountingSurchargesTable',
                optionAddOns: {
                    buttons: [{
                        class: 'btn-primary',
                        label: 'Create New',
                        tooltip: 'Create New',
                        onClick: function () {
                            $location.path('/accounting/surcharges/add');
                        }
                    }]
                },
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false,
                    colMinWidth: '135px'
                },
                headers: [
                    {
                        label: 'Internal Name',
                        viewName: 'name',
                        filter: {
                            type: 'text',
                            placeholder: 'Search',
                            onSubmit: function (header) {
                                tableActions.sendRequest(tableActions.evaluateFilter(header));
                            }
                        },
                        headerFn: function () {
                            tableActions.sort(this.filterName);
                        }
                    },
                    {
                        label: 'Account Number',
                        viewName: 'accountNumber',
                        filter: {
                            type: 'text',
                            placeholder: 'Search',
                            onSubmit: function (header) {
                                sendRequest(evaluateFilter(header));
                            }
                        },
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'Carrier',
                        viewName: 'carrierName',
                        sortName: 'carrierId',
                        filter: {
                            type: 'text',
                            placeholder: 'Search',
                            onSubmit: function (header) {
                                sendRequest(evaluateFilter(header));
                            },
                        },
                        headerFn: function () {
                            sort(this.sortName);
                        }
                    },
                    {
                        label: 'Customer',
                        viewName: 'customerName'
                    },
                ],
                data: []
            };
            const tableActions = new TableLiteFactory(tableData, {
                serviceCallback: AccountingService.SurchargeProfiles.getAll,
                callbackFormat: ['success', 'error', 'filter'],
                postRequestCallback: data => {
                    buildTableData(data);
                },
                postRequestErrorCallback: err => {
                    buildTableData(null);
                    console.log(err);
                },
                defaultFilters: {
                    size: 20,
                    page: 0,
                    sort: 'id,desc'
                }
            });
            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;

            function buildTableData(data) {
                /*** START - Building of Data ***/

                tableActions.initializeTableData(data);
                if (!data)
                    return null;
                angular.forEach(data.content, function (surcharge) {
                    surcharge.name = surcharge.name || 'N/A';
                    surcharge.accountNumber = surcharge.accountNumber || 'N/A';
                    surcharge.carrierName = surcharge.carrierId || 'N/A';

                    surcharge.customerName = {
                        type: 'multiLine', 
                        list: surcharge.customers.length !== 0 ? surcharge.customers.map(data => {
                            return data;
                        }) : ['N/A']
                    }
                    surcharge.href = '/accounting/surcharges/' + surcharge.id;
                    tableData.data.push(surcharge);
                });
                /*** END - Building of Data ***/
            }

            this.tableData = tableData;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/AccountingSurchargesTableService.js